import React, { useContext, useState, useEffect } from 'react';
import cn from 'clsx';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import PopupContext from '../../context/PopupContext.js';
import Icon from '../../atoms/Icon/index.jsx';

/**
 * PopupToggleButton component.
 */
const PopupToggleButton = ({
  className,
  popup,
  closeIcon,
  openIcon
}) => {
  const {
    activePopup,
    setActivePopup
  } = useContext(PopupContext);
  const [jsEnabled, setJsEnabled] = useState(false);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setJsEnabled(true);
  });
  const Component = jsEnabled ? 'button' : 'a';
  return /*#__PURE__*/React.createElement(Component, {
    className: cn('popup-toggle-button', className),
    type: jsEnabled ? 'button' : null,
    onClick: () => {
      setActivePopup(activePopup === popup ? null : popup);
    },
    "aria-label": t('molecules.popupToggleButton.ariaLabel.toggle', {
      popup
    }),
    "aria-haspopup": "true",
    "aria-expanded": jsEnabled ? (activePopup === popup).toString() : null,
    href: jsEnabled ? null : `#${popup}-popup`
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: "inherit",
    name: activePopup === popup ? closeIcon : openIcon
  }));
};
PopupToggleButton.defaultProps = {
  className: null
};
PopupToggleButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  /** The name of the popup to toggle. */
  popup: string.isRequired,
  /** The name of the open icon. */
  openIcon: string.isRequired,
  /** The name of the close icon. */
  closeIcon: string.isRequired
} : {};
export default PopupToggleButton;